import { render, staticRenderFns } from "./RenderPostManager.vue?vue&type=template&id=4915d768&scoped=true&"
import script from "./RenderPostManager.vue?vue&type=script&lang=js&"
export * from "./RenderPostManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4915d768",
  null
  
)

export default component.exports